import React from "react";
import {
    reduxForm,
    InjectedFormProps,
    ConfigProps,
    FormDecorator,
    formValueSelector,
} from "redux-form";
import { Button, CircularProgress, Grid, FormControlLabel } from "material-ui";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextfield from "../../../components/form/RenderTextField";
import { ReduxDispatch, ReduxState } from "../../../ducks/reducers";
import { connect } from "react-redux";
import validate from "./CreateLoginValidator";
import { blue } from "material-ui/colors";

export interface CreateLoginFormData {
    username: string | null | undefined;
    password: string | null | undefined;
    verifyPassword: string | null | undefined;
}

interface ICreateLoginFormProps {
    form: string;
    onSubmit: (data: CreateLoginFormData) => void;
}

interface ICreateLoginReduxProps {}
interface ICreateLoginDispatchProps {}

interface CreateLoginFormState {}

type CreateLoginFormProps = ICreateLoginFormProps &
    ICreateLoginReduxProps &
    ICreateLoginDispatchProps &
    InjectedFormProps<CreateLoginFormData, ICreateLoginFormProps>;

const CreateLoginForm: React.SFC<CreateLoginFormProps> = (
    props: CreateLoginFormProps
) => {
    return (
        <form onSubmit={props.handleSubmit(props.onSubmit)}>
            <Grid container>
                <Grid item xs={12} className="LoginInput">
                    <ExtendedField
                        component={renderTextfield}
                        name="username"
                        type="text"
                        placeholder=""
                        adornment=""
                        label={"Tunnus"}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12} className="LoginInput">
                    <ExtendedField
                        component={renderTextfield}
                        name="password"
                        type="password"
                        placeholder=""
                        adornment=""
                        label={"Salasana"}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12} className="LoginInput">
                    <ExtendedField
                        component={renderTextfield}
                        name="verifyPassword"
                        type="password"
                        placeholder=""
                        adornment=""
                        label={"Vahvista salasana"}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div className={"loginButton"}>
                        <Button
                            variant="raised"
                            type="submit"
                            disabled={props.submitting || props.invalid}
                        >
                            Luo tunnukset
                            {props.submitting && (
                                <CircularProgress
                                    size={24}
                                    style={{
                                        color: blue[500],
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>
    );
};

const form = reduxForm<CreateLoginFormData, ICreateLoginFormProps>({
    validate,
})(CreateLoginForm);

const selector = formValueSelector("createloginform");
const mapStateToProps = (state: ReduxState): ICreateLoginReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ICreateLoginDispatchProps => {
    return {};
};

export default connect<
    ICreateLoginReduxProps,
    ICreateLoginDispatchProps,
    ICreateLoginFormProps
>(
    mapStateToProps,
    mapDispatchToProps
)(form as any);



// WEBPACK FOOTER //
// ./src/views/profile/components/CreateLoginForm.tsx